export const CHECK_TOKEN_EXPIRED = 'CHECK_TOKEN_EXPIRED';
export const CHECKING_TOKEN_EXPIRED = 'CHECKING_TOKEN_EXPIRED';
export const CHOOSE_TEAM = 'CHOOSE_TEAM';
export const CHOOSING_TEAMS = 'CHOOSING_TEAMS';
export const GET_DEPARTMENTS = 'GET_DEPARTMENTS';
export const GET_DEPARTMENTS_DONE = 'GET_DEPARTMENTS_DONE';
export const GET_TEAMS = 'GET_TEAMS';
export const GET_TEAMS_DONE = 'GET_TEAMS_DONE';
export const GET_USER = 'GET_USER';
export const GET_USER_DONE = 'GET_USER_DONE';
export const GETTING_DEPARTMENTS = 'GETTING_DEPARTMENTS';
export const GETTING_TEAMS = 'GETTING_TEAMS';
export const GETTING_USER = 'GETTING_USER';
export const RESEND_VERIFY_EMAIL = 'RESEND_VERIFY_EMAIL';
export const RESENDING_VERIFY_EMAIL = 'RESENDING_VERIFY_EMAIL';
export const SEND_FORGET_PASSWORD_LINK = 'SEND_FORGET_PASSWORD_LINK';
export const SENDING_FORGET_PASSWORD_LINK = 'SENDING_FORGET_PASSWORD_LINK';
export const SET_LOGIN_DATUM = 'SET_LOGIN_DATUM';
export const SET_LOGIN_DATUM_DONE = 'SET_LOGIN_DATUM_DONE';
export const SET_PASSWORD = 'SET_PASSWORD';
export const SETTING_PASSWORD = 'SETTING_PASSWORD';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATING_USER = 'UPDATING_USER';
export const USER_LOGGING = 'USER_LOGGING';
export const USER_LOGIN = 'USER_LOGIN';
export const REGISTER_LINE_NOTIFY = 'REGISTER_LINE_NOTIFY';
export const UNREGISTER_LINE_NOTIFY = 'UNREGISTER_LINE_NOTIFY';
